import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { BorrowFollowEightComponent } from "../../components/borrowSystem/BorrowFollowEightComponent";
import { Footer } from "../../components/share/Footer";

export function BorrowFollowEightContainer() {
  const titleName =
    "แบบรายงานการติดตามการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545และที่แก้ไขเพิ่มเติม กย.8";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <BorrowFollowEightComponent />
      <Footer />
    </div>
  );
}
